import { getGroupFlightsSnapshotData } from '../selectors/eventTravel';

const LOAD_AIRPORTS_SUCCESS = 'event-guestside-site/airports/LOAD_AIRPORTS_SUCCESS';

const initialState = {};

export function setAirports(airports) {
  return { type: LOAD_AIRPORTS_SUCCESS, payload: { airports } };
}

const getAirportsForGroupFlights = (eventTravel) => {
  const { isGroupFlightEnabled, groupFlightSetup } = getGroupFlightsSnapshotData(eventTravel);
  if (!isGroupFlightEnabled || !groupFlightSetup.groupFlights) {
    return [];
  }
  let airportIds = [];
  groupFlightSetup.groupFlights.forEach(flight => {
    airportIds.push(flight.departingAirportId);
    airportIds.push(flight.arrivalAirportId);
    (flight.groupFlightLegs || []).forEach(leg => {
      airportIds.push(leg.departureAirportId);
      airportIds.push(leg.arrivalAirportId);
    });
  });
  return airportIds;
};

export const getAirportIdsFromSnapshot = ({
  event: {
    eventFeatureSetup: { travelAndHousing }
  },
  eventTravel
}) => {
  if (travelAndHousing && travelAndHousing.airTravel.enabled) {
    const {
      airData: {
        airRequestSetup: {
          restrictions: {
            limitDepartureAirportIds = [], limitArrivalAirportIds = []
          }, defaultSchedule: {
            departureAirportId: departureAirRequestDefault, arrivalAirportId: arrivalAirRequestDefault
          } = {}
        },
        airActualSetup: {
          defaultSchedule: {
            departureAirportId: departureAirActualDefault, arrivalAirportId: arrivalAirActualDefault
          } = {}
        } = {}
      }
    } = eventTravel;
    return [...limitDepartureAirportIds, ...limitArrivalAirportIds,
      departureAirRequestDefault, arrivalAirRequestDefault,
      departureAirActualDefault, arrivalAirActualDefault,
      ...getAirportsForGroupFlights(eventTravel)].filter(id => !!id);
  }
  return [];
};

/**
 * Creates a thunked action to load airports by ids
 * @param airportIds The ids of the airports to load.
 */
export const loadAirports = (airportIds) => async (dispatch, getState) => {
  const { accessToken, clients: { lookupClient }, airports: existingAirports } = getState();
  const uniqueAirportIds = airportIds.filter((value, index, self) => self.indexOf(value) === index);
  if (uniqueAirportIds.length) {
    const existingAirportIds = Object.keys(existingAirports);
    const newAirports = uniqueAirportIds.filter(id => !existingAirportIds.includes(id.toString()));
    if (newAirports.length) {
      const response = await lookupClient.getAirports(accessToken, newAirports);
      const { airports } = response;
      dispatch(setAirports(airports));
    }
  }
};

/**
 * Load airports data from snapshot into redux state
 */
export const loadAirportsFromSnapshot = () => async (dispatch, getState) => {
  const state = getState();
  const airportsFromSnapshot = getAirportIdsFromSnapshot(state);
  if (airportsFromSnapshot.length) {
    await dispatch(loadAirports(airportsFromSnapshot));
  }
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_AIRPORTS_SUCCESS: {
      return {
        ...state,
        ...action.payload.airports
      };
    }
    default: {
      return state;
    }
  }
}
